import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colour", "checkbox", "root"]

  static classes = ["selected"]

  select(event) {
    const selectedColour = event.params.colour
    const selectedCheckbox = event.target

    this.updateCheckboxes(selectedCheckbox)
    this.updateHiddenField(selectedColour)
    this.applyColourStyles(selectedColour)
  }

  updateCheckboxes(selectedCheckbox) {
    this.checkboxTargets.forEach(cb => {
      const label = cb.closest("label")
      label.classList.remove(this.selectedClass)

      if (cb === selectedCheckbox) {
        cb.checked = true
        label.classList.add(this.selectedClass)
      } else {
        cb.checked = false
      }
    })
  }

  updateHiddenField(colour) {
    this.colourTarget.value = colour
  }

  applyColourStyles(colour) {
    this.rootTarget.style.setProperty("--site-primary-colour", colour)
    this.rootTarget.style.setProperty("--site-primary-colour-lighter", this.hexToRgba(colour, 0.3))
    this.rootTarget.style.setProperty("--site-primary-colour-darker", this.hexToRgba(colour, 0.5))
  }

  hexToRgba(hex, alpha = 0.3) {
    hex = hex.replace(/^#/, "")
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }
}
